import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AddExpenseForm from '../components/AddExpenseForm';
import Navbar from '../components/Navbar';
import { useAuth } from '../utils/AuthContext';
import ExpenseService from '../services/ExpenseService';
import CategoryService from '../services/CategoryService';

const AddExpensePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null); // 'success' or 'error'

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    const fetchCategories = async () => {
      try {
        const userCategories = await CategoryService.getCategories();
        setCategories(userCategories.map(cat => ({ value: cat, label: cat })));
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, [navigate, isAuthenticated]);

  const handleFormSubmit = async (newExpenseData) => {
    try {
      await ExpenseService.addExpense(newExpenseData);
      console.log('Expense added successfully!');
      setMessage('Expense added successfully!');
      setMessageType('success');
      // Optionally clear the message after some time
      setTimeout(() => {
        setMessage(null);
        setMessageType(null);
        navigate('/dashboard'); // Navigate back to dashboard after adding expense
      }, 2000); // 2 seconds
    } catch (error) {
      console.error('Failed to add expense:', error);
      setMessage(`Failed to add expense: ${error.message || 'Unknown error'}`);
      setMessageType('error');
      // Optionally clear the error message after some time
      setTimeout(() => {
        setMessage(null);
        setMessageType(null);
      }, 5000); // 5 seconds
    }
  };

  const handleCategoryAdded = async (newCategoryName) => {
    try {
      await CategoryService.addCategory(newCategoryName);
      console.log(`Category '${newCategoryName}' added successfully!`);
      setMessage(`Category '${newCategoryName}' added successfully!`);
      setMessageType('success');
      const updatedCategories = await CategoryService.getCategories();
      setCategories(updatedCategories.map(cat => ({ value: cat, label: cat })));
      setTimeout(() => {
        setMessage(null);
        setMessageType(null);
      }, 2000);
    } catch (error) {
      console.error('Failed to add category:', error);
      setMessage(`Failed to add category: ${error.message || 'Unknown error'}`);
      setMessageType('error');
      setTimeout(() => {
        setMessage(null);
        setMessageType(null);
      }, 5000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 font-sans relative overflow-hidden">
      <Navbar />
      <br/>
      <br/>
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-4xl text-gray-800 mb-8 text-center">Add New Expense</h1>
        {message && (
          <div className={`p-4 mb-4 rounded-md text-white text-center ${messageType === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
            {message}
          </div>
        )}
        <AddExpenseForm categories={categories} onAddExpense={handleFormSubmit} onCategoryAdded={handleCategoryAdded} />
      </div>
    </div>
  );
};

export default AddExpensePage;
